export const mentors = [
  {
    name: "Fanny Kartika Sari",
    role: "Data Consultan @ PT Velo Citra teknologi",
    description: "Data Science Mentor",
    university: "Institut Teknologi Bandung",
    linkedin: "https://www.linkedin.com/in/fannykartikasari/",
    image: "/images/mentors/fanny.jpg"
  },
  {
    name: "Melani Putri Azalia",
    role: "Data Analyst @ PT Velo Citra Teknologi",
    description: "Data Analyst Mentor",
    university: "Universitas Gunadarma",
    linkedin: "https://www.linkedin.com/in/azalliamelani/",
    image: "/images/mentors/melani.jpg"
  },
  {
    name: "Melly",
    role: "Data Analyst Consultant @ PT Velo Citra Teknologi",
    description: "Data Analyst Mentor",
    university: "Institut Teknologi Bandung",
    linkedin: "https://www.linkedin.com/in/mellygsln/",
    image: "/images/mentors/melly.jpg"
  },
  {
    name: "Shelma Salsabila",
    role: "Data Scientist @ PT Velo Citra Teknologi",
    description: "Data Science Mentor",
    university: "Institut Teknologi Bandung",
    linkedin: "https://www.linkedin.com/in/shelma-salsabila-2b699a219/",
    image: "/images/mentors/shelma.jpg"
  },
  {
    name: "Wimar Abdurrachman",
    role: "Cloud Engineer @ PT Velo Citra Teknologi",
    description: "Cloud & Google Workspace Mentor",
    university: "Universitas Indonesia",
    linkedin: "https://www.linkedin.com/in/wimar-abdurrachman/",
    image: "/images/mentors/wimar.jpg"
  },
];
